import * as React from "react";
import { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import Select from "react-select";
import cargandoCard from "../../components/cargando-card";
import SinAccesoCard from "../../components/sin-acceso-card";
import { useTranslation } from "react-i18next";
import { Responsive, WidthProvider } from "react-grid-layout";
import { Plus, Save, Search } from "lucide-react";
import { getHeaders } from "../../api/utils";
import "../../styles/react-grid-layout.css";
import "../../styles/react-resizable.css";
import ChartCard from "./chartcard";
import Calendar from "../../components/calendar";
import { obtenerListaDetallePedido } from "../../api/api-detalle-pedido";
import { GET, POST, } from "../../utils/const/http-const";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
import { CHART_TYPES_VALUES } from "./char_types";
import { sharedObtenerListaPorAtributo } from "../../utils/shared-functions";
import shortid from "shortid";
import {
    STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB,
} from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";

const ResponsiveGridLayout = WidthProvider(Responsive);

const DASHBOARD_KEY = "dashboard_tms_settings"; // Backend storage key
const DEFAULT_BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
const DEFAULT_COLS = { lg: 12, md: 10, sm: 8, xs: 6, xxs: 4 };
const STORAGE_KEY = "dashboard_layouts_tms_v3"; // LocalStorage fallback

const CARD_W = 4;
const CARD_H = 8;

export default function DashboardPage() {

    const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
    const { t } = useTranslation();

    const CHART_TYPES = [
        { value: CHART_TYPES_VALUES.piechartestados, label: t("chart_pie_chart_estados"), width: 8, height: 12 },
        { value: CHART_TYPES_VALUES.estadopagos, label: t("chart_estado_pagos"), width: 8, height: 12 },
    ];

    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

    // const [listaVehiculos, setListaVehiculos] = useState([]);
    // const [vehiculoSelected, setVehiculoSelected] = useState(null);

    // const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));

    // const [infoDashboardAlcaldia, setInfoDashboardAlcaldia] = useState([]);

    const [counter, setCounter] = useState(0);
    const [items, setItems] = useState([]);
    const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    const [hydrated, setHydrated] = useState(false);
    const [selectedChartType, setSelectedChartType] = useState(null);

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    const lastLayoutRef = useRef(null);
    const layoutsRef = useRef(null);
    const currentBreakpointRef = useRef(currentBreakpoint);
    currentBreakpointRef.current = currentBreakpoint;

    const [btnBuscar, setBtnBuscar] = useState(false);
    const [btnAgregar, setBtnAgregar] = useState(false);
    const [btnGuardar, setBtnGuardar] = useState(false);
    const [btnEliminar, setBtnEliminar] = useState(false);

    const [listaVehiculos, setListaVehiculos] = useState([]);
    const [vehiculoSelected, setVehiculoSelected] = useState(null);

    const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));

    // const [listaDetallePedido, setListaDetallePedido] = useState([]);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        let tieneAccesoAlModulo = false;
        try {
            let objEnviar = {};
            if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
                tieneAccesoAlModulo = true;
                setBtnBuscar(true);
                setBtnAgregar(true);
                setBtnGuardar(true);
                setBtnEliminar(true);
            }
            if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
                const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
                objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
                const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
                // console.log('response obtenerPermisoRolUsuarioWeb');
                // console.log(response);
                if (response.error === false && response.data !== undefined) {
                    const permisos = JSON.parse(response.data.permisos);
                    // console.log('permisos');
                    // console.log(permisos);
                    if (Array.isArray(permisos) && permisos.length > 0) {
                        const permisosPage = permisos.find(p => p.value === PAGE_ID.DASHBOARD);
                        // console.log('permisosPage');
                        // console.log(permisosPage);
                        if (permisosPage !== undefined && permisosPage !== null) {
                            // console.log('permisosPage.checked');
                            // console.log(permisosPage.checked);
                            tieneAccesoAlModulo = permisosPage.checked;
                            if (tieneAccesoAlModulo === false) {
                                // console.log('no tiene acceso al modulo');
                                return;
                            }
                            const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
                            const permisoBtnAgregar = permisosPage.acciones.find(a => a.value === 'btn_agregar');
                            const permisoBtnGuardar = permisosPage.acciones.find(a => a.value === 'btn_guardar');
                            const permisoBtnEliminar = permisosPage.acciones.find(a => a.value === 'btn_eliminar');
                            setBtnBuscar(permisoBtnBuscar.checked);
                            setBtnAgregar(permisoBtnAgregar.checked);
                            setBtnGuardar(permisoBtnGuardar.checked);
                            setBtnEliminar(permisoBtnEliminar.checked);
                        }
                    }
                }
            }
            // console.log('tieneAccesoAlModulo');
            // console.log(tieneAccesoAlModulo);
            if (tieneAccesoAlModulo === true) {
                const listaVeh = await obtenerTodasLasUnidades();
                setListaVehiculos(listaVeh);
                cargarDatos();
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            // console.log('finally');
            setCargandoPage(false);
            setTieneAccesoAlModulo(tieneAccesoAlModulo);
        }
    };

    const cargarDatos = async () => {
        try {
            cargarLayouts();
        } catch (error) {
            console.error("Error cargando datos iniciales:", error);
        } finally {
            setHydrated(true);
            setProcessingVisible(false);
        }
    };

    const baseLayout = () => {
        return [];
    };

    const [layouts, setLayouts] = useState({
        lg: baseLayout(),
        md: baseLayout(),
        sm: baseLayout(),
        xs: baseLayout(),
        xxs: baseLayout(),
    });
    layoutsRef.current = layouts;

    const cargarLayouts = async () => {
        try {
            let { success, message, layouts: serverLayouts, items: serverItems } = await fetch(
                `https://gestiondeflota.boltrack.net/apiultimamillav3/api/dashboard/${encodeURIComponent(DASHBOARD_KEY)}`,
                {
                    headers: getHeaders(),
                    method: GET,
                }
            ).then((res) => res.json());
            // console.log('response cargarLayouts');
            // console.log(success);
            // console.log(message);
            // console.log(serverLayouts);
            // console.log(serverItems);
            if (success === true) {
                // let { layouts: serverLayouts, items: serverItems } = await res.json();

                // Si el backend envía JSON como string, parseamos
                if (typeof serverLayouts === "string") {
                    try {
                        serverLayouts = JSON.parse(serverLayouts);
                    } catch (err) {
                        console.log('error parse serverLayouts', err);
                    }
                }
                if (typeof serverItems === "string") {
                    try {
                        serverItems = JSON.parse(serverItems);
                    } catch (err) {
                        console.log('error parse serverItems', err);
                    }
                }

                // Layouts seguros
                const emptyLayouts = { lg: [], md: [], sm: [], xs: [], xxs: [] };
                const safeLayouts =
                    serverLayouts && typeof serverLayouts === "object"
                        ? serverLayouts
                        : emptyLayouts;
                setLayouts(safeLayouts);
                lastLayoutRef.current = JSON.stringify(safeLayouts[currentBreakpoint] || []);

                // Elegimos el layout no vacío más razonable (bp actual, si no lg, si no md, etc.)
                const pick =
                    safeLayouts[currentBreakpoint] &&
                        safeLayouts[currentBreakpoint].length
                        ? safeLayouts[currentBreakpoint]
                        : safeLayouts.lg && safeLayouts.lg.length
                            ? safeLayouts.lg
                            : safeLayouts.md && safeLayouts.md.length
                                ? safeLayouts.md
                                : safeLayouts.sm && safeLayouts.sm.length
                                    ? safeLayouts.sm
                                    : safeLayouts.xs && safeLayouts.xs.length
                                        ? safeLayouts.xs
                                        : safeLayouts.xxs || [];

                const byId = new Map(pick.map((l) => [l.i, l]));
                console.log('serverItems');
                console.log(serverItems);
                // serverItems = JSON.parse(serverItems);
                // console.log('serverItems');
                // console.log(serverItems);
                const restoredItems = Array.isArray(serverItems)
                    ? serverItems.map((m) => {
                        const pos = byId.get(m.i);
                        return {
                            i: m.i,
                            type: m.type,
                            title: m.title,
                            x: pos?.x ?? 0,
                            y: pos?.y ?? Infinity,
                            w: pos?.w ?? CARD_W,
                            h: pos?.h ?? CARD_H,
                        };
                    })
                    : [];

                setItems(restoredItems);
                setCounter(calcCounterFromItems(restoredItems));
                // console.log('restoredItems', restoredItems);
                // Fetch data for each restored card, passing the detallePedido
                console.log('restoredItems');
                console.log(restoredItems);
                restoredItems.forEach((item) => {
                    setCardData(item.i, item.type);
                });
            }
            if (success === false) {
                showToast(message, "error");
                // No hay nada guardado -> dashboard vacío
                setLayouts({ lg: [], md: [], sm: [], xs: [], xxs: [] });
                setItems([]);
                setCounter(0);
            }
        } catch (error) {
            console.error("Error cargando layouts:", error);
            setLayouts({ lg: [], md: [], sm: [], xs: [], xxs: [] });
            setItems([]);
            setCounter(0);
        }
    };

    const calcCounterFromItems = (list) => {
        const n = Math.max(
            0,
            ...list.map((m) => parseInt(m.i, 10)).filter((x) => !Number.isNaN(x))
        );
        return n;
    };

    const setCardData = async (cardId, type) => {
        try {
            console.log('setCardData');
            console.log('cardId', cardId);
            console.log('type', type);
            // console.log(' listaDetallePedido', listaDetallePedido);
            // if (infoDashboard.length === 0) {
            // const infoDashboard = listaDetallePedido;
            // }
            let listaDetallePedido = [];
            const objEnviar = {
                fechaEntrega: fechaSelected,
                placa: vehiculoSelected?.value,
            };
            const response = await obtenerListaDetallePedido(objEnviar, t);
            console.log('response setCardData', response);
            if (response.error === false && response.data) {
                listaDetallePedido = (response.data);
            }
            let charData = {};
            switch (type) {
                case CHART_TYPES_VALUES.piechartestados:
                    const listaEstados = sharedObtenerListaPorAtributo("idEstado", listaDetallePedido);
                    // console.log('listaEstados', listaEstados);
                    let pieData = [];
                    for (const estado of listaEstados) {
                        // console.log('estado', estado);
                        const detallePedidoEstado = listaDetallePedido.filter(dp => dp.idEstado === estado);
                        // console.log('detallePedidoEstado', detallePedidoEstado);
                        pieData.push({ name: detallePedidoEstado[0].estado, value: detallePedidoEstado.length, fill: detallePedidoEstado[0].colorEstado, detallePedido: detallePedidoEstado });
                    }
                    // console.log('pieData', pieData);
                    charData = { pieData };
                    break;
                case CHART_TYPES_VALUES.estadopagos:
                    // let estadopagos = {};
                    // console.log('estadopagos listaDetallePedido');
                    // console.log(listaDetallePedido);
                    let listaEstadosPago = [];
                    for (const detallePedido of listaDetallePedido) {
                        let objDetalle = {};
                        objDetalle.cliente = detallePedido.cliente;
                        objDetalle.numeroDocumento = detallePedido.numeroDocumento;
                        objDetalle.labelPlaca = detallePedido.labelPlaca;
                        objDetalle.productos = detallePedido.productos;
                        objDetalle.estadoPago = [];
                        if (Array.isArray(detallePedido.jsonFormularioWorkflow)) {
                            for (const workflow of detallePedido.jsonFormularioWorkflow) {
                                if (workflow.type === 'estado_de_pago') {
                                    if (Array.isArray(workflow.estadoDePagoSelected)) {
                                        for (const estadoPago of workflow.estadoDePagoSelected) {
                                            let objEstadoPago = {};
                                            objEstadoPago.descripcion = estadoPago.descripcion;
                                            objEstadoPago.detalle = [];
                                            if (Array.isArray(estadoPago.dynamicFields)) {
                                                for (const dynamicField of estadoPago.dynamicFields) {
                                                    const objDetalleEstadoPago = {
                                                        descripcion: dynamicField.key,
                                                        type: dynamicField.type,
                                                        value: dynamicField.value,
                                                    };
                                                    objEstadoPago.detalle.push(objDetalleEstadoPago);
                                                }
                                            }
                                            objDetalle.estadoPago.push(objEstadoPago);
                                        }
                                    }
                                }
                            }
                        }
                        listaEstadosPago.push(objDetalle);
                    }
                    console.log('listaEstadosPago');
                    console.log(listaEstadosPago);
                    charData = { listaEstadosPago };
                    break;

                default:
                    console.warn(`Unknown chart type: ${type}`);
                    break;
            }
            updateCardData(
                cardId,
                {
                    isLoading: false,
                    data: charData,
                }
            );
        } catch (error) {
            // console.error(`[Card ${cardId}] Error fetching data:`, error);
            updateCardData(
                cardId,
                {
                    isLoading: false,
                    hasError: true,
                    errorMessage: error.message,
                }
            );

            showToast(
                `Error al cargar datos de la tarjeta: ${error.message || "Error desconocido"
                }`,
                "error"
            );
        }
    };

    const updateCardData = (cardId, updates) => {
        // console.log('updateCardData');
        // console.log('cardId', cardId);
        // console.log('updates', updates);
        setItems((prevItems) =>
            prevItems.map((item) =>
                item.i === cardId ? { ...item, ...updates } : item
            )
        );
    };

    const showToast = (message, type = "warning", durationMs = 3000) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
        }, durationMs);
    };

    const getTypeWidth = (type) => {
        const chartType = CHART_TYPES.find((t) => t.value === type);
        return chartType ? chartType.width : CARD_W;
    };

    const getTypeHeight = (type) => {
        const chartType = CHART_TYPES.find((t) => t.value === type);
        return chartType ? chartType.height : CARD_H;
    };

    const addItem = () => {
        if (selectedChartType === null) {
            showToast(t("alert_debe_seleccionar_grafico"), "error");
            return;
        }
        // console.log('addItem');
        // console.log(selectedChartType);
        const type = selectedChartType.value;
        const id = shortid.generate();
        setCounter((c) => (c || 0) + 1);

        const initialCard = {
            i: id,
            type,
            title: `Card ${id}`,
            x: 0,
            y: Infinity,
            w: getTypeWidth(type),
            h: getTypeHeight(type),
            isLoading: true,
            data: null,
        };

        // Add card to visible items list
        setItems((prev) => [...prev, initialCard]);

        // Update layouts for all breakpoints
        setLayouts((prev) => {
            const next = { ...prev };
            Object.keys(next).forEach((bp) => {
                next[bp] = [
                    ...(next[bp] || []),
                    {
                        i: id,
                        x: 0,
                        y: Infinity,
                        w: getTypeWidth(type), // ✅ Use chart type specific width
                        h: getTypeHeight(type), // ✅ Use chart type specific height
                    },
                ];
            });
            return next;
        });
        setCardData(id, type);

        // Scroll to the new card after DOM updates
        setTimeout(() => {
            // Try multiple selectors to find the card
            let newCard = document.querySelector(`[data-grid]`);

            // Find the card with matching key
            const allCards = document.querySelectorAll("[data-grid]");
            allCards.forEach((card) => {
                const dataGrid = card.getAttribute("data-grid");
                if (dataGrid && dataGrid.includes(`"i":"${id}"`)) {
                    newCard = card;
                }
            });

            if (newCard) {
                newCard.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                });
            } else {
                // Fallback: scroll to bottom
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: "smooth",
                });
            }
        }, 500);
    };

    const removeItem = (id) => {
        setItems((prev) => prev.filter((it) => it.i !== id));
        setLayouts((prev) => {
            const next = { ...prev };
            Object.keys(next).forEach((bp) => {
                next[bp] = (next[bp] || []).filter((l) => l.i !== id);
            });
            return next;
        });
    };

    const onLayoutChange = useCallback((currLayout, allLayouts) => {
        if (!hydrated) return; // evita pisar con layout inicial
        const bp = currentBreakpointRef.current;
        const layoutsCurrent = layoutsRef.current;
        const nextLayouts = allLayouts && Object.keys(allLayouts).length
            ? allLayouts
            : { ...layoutsCurrent, [bp]: currLayout };
        const snapshot = JSON.stringify(nextLayouts[bp] || []);
        if (lastLayoutRef.current === snapshot) return;
        lastLayoutRef.current = snapshot;
        setLayouts(nextLayouts);
        setItems((prev) =>
            prev.map((it) => {
                const found = currLayout.find((l) => l.i === it.i);
                return found
                    ? { ...it, x: found.x, y: found.y, w: found.w, h: found.h }
                    : it;
            })
        );
    }, [hydrated]);

    const onBreakpointChange = useCallback((bp) => {
        setCurrentBreakpoint(bp);
        cargarLayouts();
        if (!hydrated) return;
        const layoutsCurrent = layoutsRef.current;
        const pick =
            layoutsCurrent[bp] && layoutsCurrent[bp].length
                ? layoutsCurrent[bp]
                : layoutsCurrent.lg && layoutsCurrent.lg.length
                    ? layoutsCurrent.lg
                    : layoutsCurrent.md && layoutsCurrent.md.length
                        ? layoutsCurrent.md
                        : layoutsCurrent.sm && layoutsCurrent.sm.length
                            ? layoutsCurrent.sm
                            : layoutsCurrent.xs && layoutsCurrent.xs.length
                                ? layoutsCurrent.xs
                                : layoutsCurrent.xxs || [];
        const byId = new Map(pick.map((l) => [l.i, l]));
        setItems((prev) =>
            prev.map((it) => {
                const pos = byId.get(it.i);
                return pos
                    ? { ...it, x: pos.x, y: pos.y, w: pos.w, h: pos.h }
                    : it;
            })
        );
    }, [hydrated]);


    const renderCard = (item) => {
        try {
            // console.log('renderCard item', item);
            return (
                <div
                    key={item.i}
                    data-grid={{
                        i: item.i,
                        x: item.x,
                        y: item.y,
                        w: item.w,
                        h: item.h,
                    }}
                >
                    <ChartCard
                        type={item.type}
                        idCard={item.i}
                        onRemove={removeItem}
                        isLoading={item.isLoading}
                        data={item.data}
                        hasError={item.hasError}
                        errorMessage={item.errorMessage}
                    />
                </div>
            );
        } catch (err) {
            console.log('renderCard err', err);
            return null;
        }
    };

    const renderDashboardContent = () => {
        try {
            return (
                <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                    <ResponsiveGridLayout
                        className="layout"
                        layouts={layouts}
                        breakpoints={DEFAULT_BREAKPOINTS}
                        cols={DEFAULT_COLS}
                        rowHeight={10}
                        margin={[12, 12]}
                        containerPadding={[12, 12]}
                        isBounded={true}
                        isDraggable={true}
                        isResizable={true}
                        onLayoutChange={onLayoutChange}
                        onBreakpointChange={onBreakpointChange}
                        draggableHandle=".drag-handle"
                        compactType="vertical"
                    >
                        {items.length === 0 ? (
                            <div
                                key="empty"
                                className="text-sm text-neutral-500 min-w-[250px]"
                            >
                                {t("label_dashboard_vacio")}
                            </div>
                        ) : (
                            items.map((item) => renderCard(item))
                        )}
                    </ResponsiveGridLayout>
                </div>
            );
        } catch (err) {
            console.log('renderDashboardContent err', err);
            return null;
        }
    };

    const guardarLayout = async () => {
        try {
            showToast(t("label_guardando_layout"));
            setProcessingVisible(true);
            const payload = {
                bp: currentBreakpoint,
                layout: (layouts[currentBreakpoint] || []).map(({ i, x, y, w, h }) => ({
                    i,
                    x,
                    y,
                    w,
                    h,
                })),
                items: items.map(({ i, type, title }) => ({ i, type, title })),
            };
            const { success, message } = await fetch(
                `https://gestiondeflota.boltrack.net/apiultimamillav3/api/dashboard/${encodeURIComponent(DASHBOARD_KEY)}`,
                {
                    method: POST,
                    headers: getHeaders(),
                    body: JSON.stringify(payload),
                }
            ).then((res) => res.json());
            // console.log('response guardarLayout');
            // console.log(success);
            // console.log(message);
            if (success === true) {
                showToast(
                    t("label_configuracion_guardada_servidor"),
                    "success"
                );
            } else {
                // Server error, save locally as fallback
                localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
                showToast(
                    t("label_configuracion_guardada_localmente") ||
                    "warning"
                );
            }
        } catch (error) {
            // Network error, save locally
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    bp: currentBreakpoint,
                    layout: layouts[currentBreakpoint] || [],
                    items: items.map(({ i, type, title }) => ({ i, type, title })),
                })
            );
            showToast(
                t("label_configuracion_guardada_localmente") ||
                "warning"
            );
        } finally {
            setProcessingVisible(false);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return SinAccesoCard();
            }
            return (
                <div className="m-4">
                    <div className="flex justify-between items-center">
                        <div className="grid grid-cols-12 gap-4 w-full">
                            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                <h1 className="text-2xl font-bold">DASHBOARD</h1>
                            </div>
                            <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
                                <div className="flex justify-end gap-2">
                                    <div>
                                        <Select
                                            options={CHART_TYPES}
                                            value={selectedChartType}
                                            onChange={(option) => setSelectedChartType(option)}
                                            placeholder={t("placeholder_seleccione_grafico")}
                                            isClearable={true}
                                            isSearchable={true}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                    <div className="flex gap-2">
                                        {btnAgregar === true &&
                                            <button
                                                onClick={() => addItem(selectedChartType)}
                                                className="group inline-flex items-center gap-2 rounded-2xl border border-neutral-200 px-3 py-2 text-sm shadow-sm bg-blue-50 transition-all duration-200 hover:bg-blue-100 hover:shadow-md hover:scale-[1.02] hover:border-blue-200"
                                                title={t("label_agregar_grafico_seleccionado")}
                                            >
                                                <Plus className="h-4 w-4 transition-transform duration-200 group-hover:scale-125 group-hover:-translate-y-0.5 group-hover:rotate-12" /> {t("label_agregar")}
                                            </button>
                                        }
                                        {btnGuardar === true &&
                                            <button
                                                onClick={() => { guardarLayout(); }}
                                                className="group inline-flex items-center gap-2 rounded-2xl border border-neutral-200 px-3 py-2 text-sm shadow-sm bg-blue-50 transition-all duration-200 hover:bg-blue-100 hover:shadow-md hover:scale-[1.02] hover:border-blue-200"
                                                title={t("label_guardar_layout")}
                                            >
                                                <Save className="h-4 w-4 transition-transform duration-200 group-hover:scale-125 group-hover:-translate-y-0.5 group-hover:rotate-12" /> {t("label_guardar")}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <label className="block text-[#0F3457] font-semibold" htmlFor="listaVehiculos">
                                {t("label_vehiculo")}
                            </label>
                            <Select
                                options={listaVehiculos}
                                isSearchable={true}
                                isClearable={true}
                                value={vehiculoSelected}
                                onChange={(event) => setVehiculoSelected(event)}
                                placeholder={t("placeholder_seleccione_vehiculo")}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <label
                                htmlFor="calendar"
                                className="block text-md font-medium text-gray-700"
                            >
                                {t("label_fecha")}
                            </label>
                            <Calendar
                                value={fechaSelected}
                                onChange={(date) => setFechaSelected(date)}
                                placeholder={t("placeholder_seleccione_fecha")}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            {btnBuscar === true &&
                                <>
                                    <label className="block text-sm font-medium text-gray-700">&nbsp;</label>
                                    <button
                                        onClick={() => { cargarDatos(); }}
                                        className="group inline-flex items-center gap-2 rounded-2xl border border-neutral-200 px-3 py-2 text-sm shadow-sm bg-blue-50 transition-all duration-200 hover:bg-blue-100 hover:shadow-md hover:scale-[1.02] hover:border-blue-200"
                                        title={t("label_buscar")}
                                    >
                                        <Search className="h-4 w-4 transition-transform duration-200 group-hover:scale-125 group-hover:-translate-y-0.5 group-hover:rotate-12" /> {t("label_buscar")}
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">

                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        {renderDashboardContent()}
                    </div>
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div >
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
};